/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { AxiosResponse } from "axios";

import { ApiErrorCode } from "~/constants";

const getApiErrorCodeFromResponse = (response: AxiosResponse) => {
  // Some endpoints return error codes in the success field and success is a possible code too :')
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const code = (response?.data?.code ?? response?.data?.success?.code) as ApiErrorCode;
  if (code && code !== ApiErrorCode.SUCCESS) {
    return code;
  }

  return null;
};

export default getApiErrorCodeFromResponse;
